export const PRICE_ENQUIRY_LIST = "price_enquiry_list";
export const PRICE_ENQUIRY_LIST_SUCCESSFULL = "Price_enquiry_list_successfull";
export const ADD_PRICE_ENQUIRY = "add_price_enquiry";
export const ADD_PRICE_ENQUIRY_SUCCESSFUL = "add_price_enquiry_successfull";
export const PRICE_ENQUIRY_LINEITEMS = "price_enquiry_lineitems";
export const GET_PRICE_ENQUIRY_BYID = "get_price_enquiry_byid";
export const GET_PRICE_ENQUIRY_BYID_SUCCESSFUL = "get_price_enquiry_byid_successfull";